export default "__VITE_ASSET__CywG6vCb__"